var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-More_Info"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "More_Info",
    "data-name": "More Info",
    clipPath: "url(#clip-More_Info)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9053",
    "data-name": "Group 9053",
    transform: "translate(14535.84 -14094.41)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_258",
    "data-name": "Ellipse 258",
    cx: 18.18,
    cy: 18.18,
    r: 18.18,
    transform: "translate(-14535.25 14095)",
    fill: "#0072ce"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9030",
    "data-name": "Group 9030",
    transform: "translate(-14522.07 14104.564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18994",
    "data-name": "Path 18994",
    d: "M0,0,7.183,7.184",
    transform: "translate(5.231 7.287) rotate(45)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_374",
    "data-name": "Ellipse 374",
    cx: 2.46,
    cy: 2.46,
    rx: 2.46,
    ry: 2.46,
    transform: "translate(2.773 -0.872)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreInfo);
export default __webpack_public_path__ + "static/media/More Info.aca4220deac50a79561845363125859b.svg";
export { ForwardRef as ReactComponent };